export default __webpack_public_path__ + "static/media/oncology3.b9f5b79a.jpg";